<template>
  <div class="bg-grey">
    <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">Sustainable Plastics</h2>
  </div>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">
        <div class="content">

          <ContentsTextWithImage
            title="Sustainable Plastics"
            image-url="/pages/products/sustainable-plastics/sus-1.jpg"
            :contents="[
              'Global warming is requiring businesses to be more concerned about environmental impact from their activities. Most major brands are taking sustainability initiatives seriously by using raw materials that are from sustainable sources to reduce Co2 emission such as using bio base feedstock instead of fossil fuels or reuse PET and PP bottles from land and ocean waste to support circular economy',
            ]"
            is-white-content="true"
            :is-content-small-text="true"
            left-width="39.821%"
            right-width="60.179%"
          />

        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-bottom bg-grey">
    <div class="container page-container">

      <div class="content">
        <div class="row m-0">
          <div class="col-12 col-md-4 p-0">
            <div class="content">
              <!-- PRODUCT CARD -->
              <div class="product-card">
                <div class="product-card-image">
                  <a href="/th/plastics/products/sustainable-plastics/mechanical-recycling">
                    <img src="/pages/products/sustainable-plastics/mech.jpg" alt="">
                  </a>
                </div>
                <div class="product-card-content">
                  <a href="/th/plastics/products/sustainable-plastics/mechanical-recycling">
                    <span class="product-card-title">Mechanical Recycling</span>
                  </a>
                  <ul>
                    <li>Consistent in quality and color</li>
                    <li>Certified recycled content</li>
                    <li>Performance closes to virgin material</li>
                    <li>Up to 80% of PCR content</li>
                    <li>Ocean bound available</li>
                  </ul>
                </div>
              </div>
  
              <!-- PRODUCT CARD -->
            </div>
          </div>
  
          <div class="col-12 col-md-4 p-0">
            <div class="content">
              <!-- PRODUCT CARD -->
              <div class="product-card">
                <div class="product-card-image">
  
                  <a href="/th/plastics/products/sustainable-plastics/chemical-recycling">
                    <img src="/pages/products/sustainable-plastics/chem.jpg" alt="">
                  </a>
                </div>
                <div class="product-card-content">
                  <a href="/th/plastics/products/sustainable-plastics/chemical-recycling">
                    <span class="product-card-title">Chemical Recycling</span>
                  </a>
                  <ul>
                    <li>High quality like virgin material</li>
                    <li>Certified recycled content</li>
                    <li>Food grade is possible</li>
                    <li>Green content up to 100%</li>
                    <li>More color space</li>
                    <li>Ocean bound available</li>
                  </ul>
                </div>
              </div>
  
              <!-- PRODUCT CARD -->
            </div>
          </div>
          <div class="col-12 col-md-4 p-0">
            <div class="content">
              <!-- PRODUCT CARD -->
              <div class="product-card">
                <div class="product-card-image">
                  <a href="/th/plastics/products/sustainable-plastics/bio-based-material">
                    <img src="/pages/products/sustainable-plastics/bio.jpg" alt="">
                  </a>
                </div>
                <div class="product-card-content">
                  <a href="/th/plastics/products/sustainable-plastics/bio-based-material">
                    <span class="product-card-title">Bio-based material</span>
                  </a>
                  <ul>
                    <li>Same quality like virgin material</li>
                    <li>Use feedstock from non-food products</li>
                    <li>Food grade is possible</li>
                    <li>All color space</li>
                    <li>Better carbon footprint</li>
                    <li>Bio content certified by ISCC</li>
                  </ul>
                </div>
              </div>
  
              <!-- PRODUCT CARD -->
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title: 'Sustainable Plastics - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>


.section-product-detail-page .page-content {
  padding: 72px 0;
}
.section-product-detail-page.section-bottom {
  padding: 60px 0;
}

.section-product-detail-page.section-bottom .page-container {
  padding-left: 12px;
  padding-right: 12px;
}

@media screen and (min-width: 820px) and (max-width: 1024px) {
  .section-product-detail-page.section-bottom .page-container {
    padding: 0;
  }
}

.product-card {
  background: white;
  border-radius: 16px;
}

.product-card .product-card-title {
  font-family: 'Myriad-Pro', sans-serif;
  font-weight: 400;
  font-size: 21px;
  line-height: 1.2;
  color: #000000B8;
  display: inline-block;
  margin-bottom: 25px;
}

.product-card .product-card-content {
  padding-bottom: 30px;
}

.product-card .product-card-content ul {
  padding: 0;
}

.product-card .product-card-content ul li {
  margin-left: 23px;
  letter-spacing: -0.2px;
}
</style>
